import { SearchInput } from "react-admin";
import QuickFilter from "../ui/quick-filter";

const CustomFilterDefault = [
  <SearchInput source="q" alwaysOn />,
  <QuickFilter source="activated" label="Ativos" defaultValue={true} />,
  <QuickFilter source="disabled" label="Desativados" defaultValue={true} />
];

export default CustomFilterDefault;
